// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__QtfEM","progressBar":"style_progressBar__yM1pq","countDown":"style_countDown__9s5Kp","logo":"style_logo__d3L2Q","img":"style_img__zv9Mj"};